import React, { useState } from 'react';
import Toggle from '@/components/toggle/Toggle';
import { PersonalizationContext } from '@contensis/personalization';
import {
  DeveloperToolsCardsStyled,
  DeveloperToolsCardStyled,
} from './DeveloperToolsCards.styled';

const Done = () => {
  return (
    <div className="done">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M9.99999 14.1428L7.33333 11.5714L6 13L10 17L18 8.99997L16.6667 7.57141L9.99999 14.1428Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="description">Done</div>
    </div>
  );
};

interface DeveloperToolsCardsProps {
  className?: string;
  context?: PersonalizationContext;
}

const DeveloperToolsCards = ({
  className,
  context,
}: DeveloperToolsCardsProps) => {
  const [hasResetStorage, setResetStorage] = useState(false);
  const [hasResetSession, setResetSession] = useState(false);
  const [hasPreviewManifest, setPreviewManifest] = useState(!!context?.preview);

  return (
    <DeveloperToolsCardsStyled className={className}>
      <DeveloperToolsCardStyled>
        <div className="heading">
          <div className="title">Storage</div>
          <div className="description">
            Clear all stored personalisation data for this website. This does
            not affect other site data.
          </div>
        </div>
        <div className="action">
          <button
            data-id="panel-btn"
            type="button"
            onClick={() => {
              setResetStorage(true);
              context?.reset();
            }}
          >
            <span className="focus-ring" />
            Reset storage
          </button>
          {hasResetStorage ? <Done /> : null}
        </div>
      </DeveloperToolsCardStyled>

      <DeveloperToolsCardStyled>
        <div className="heading">
          <div className="title">Session</div>
          <div className="description">
            Clears any personalisation session data for this website. This does
            not affect other site data.
          </div>
        </div>
        <div className="action">
          <button
            data-id="panel-btn"
            type="button"
            onClick={() => {
              setResetSession(true);
              context?.reset({ session: true });
            }}
          >
            <span className="focus-ring" />
            Reset session
          </button>
          {hasResetSession ? <Done /> : null}
        </div>
      </DeveloperToolsCardStyled>

      <DeveloperToolsCardStyled>
        <div className="heading">
          <div className="title">Preview mode</div>
          <div className="description">
            Use the latest manifest file where changes haven’t yet been
            published
          </div>
        </div>
        <div className="action">
          <Toggle
            isActive={hasPreviewManifest}
            label="Use latest manifest"
            onChange={() => {
              if (context) {
                context.preview = !context.preview;
                setPreviewManifest(context.preview);
                context.reset({ manifest: true });
              }
            }}
          />
        </div>
      </DeveloperToolsCardStyled>
    </DeveloperToolsCardsStyled>
  );
};

export default DeveloperToolsCards;
